import { IconArrowNarrowDown } from "@tabler/icons-react";
import { cn } from "../../lib/utils";

type ScrollDownButtonProps = {
  onClick: () => void;
  visible: boolean;
  className?: string;
};

export function ScrollDownButton({
  onClick,
  visible,
  className,
}: ScrollDownButtonProps): React.ReactElement {
  return (
    <button
      type="button"
      aria-label="Scroll to bottom"
      onClick={onClick}
      className={cn(
        "size-[38px] rounded-full",
        "bg-[rgba(255,255,255,0.72)] backdrop-blur-[20px]",
        "border border-solid border-[rgba(11,17,16,0.14)]",
        "shadow-[0px_2px_8px_rgba(0,0,0,0.08)]",
        "flex items-center justify-center",
        "cursor-pointer outline-none",
        "transition-opacity duration-200",
        visible ? "opacity-100" : "opacity-0 pointer-events-none",
        className
      )}
    >
      <IconArrowNarrowDown size={24} color="#0b1110" />
    </button>
  );
}
